import ouiBase from '@goldwasserexchange/oui';
import { makeSelectedFinancialProductWithRequiredLogic } from './make';
export function useMakeSelectedFinancialProductWithRequiredLogicOnPrimaryDimension(alternatives) {
    var financialProduct = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
    return makeSelectedFinancialProductWithRequiredLogic(financialProduct)(alternatives);
}
